import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { queryClient } from "../../../../queryClient";
import { getRpcClient } from "../../../../rpc-browser-sdk";

function getTripAssignationStateQueryKey(orderId: string, vehicleIndex: number) {
    return ["tripAssignationState", orderId, vehicleIndex];
}

type TripAssignationState = Awaited<
    ReturnType<ReturnType<typeof getRpcClient>["tripAssignationState"]["getTripAssignationState"]>
>;

type TripAssignationStateQueryOptions = Pick<UseQueryOptions<TripAssignationState, Error>, "staleTime" | "gcTime">;

export function useTripAssignationState({
    orderId,
    vehicleIndex,
    options,
}: {
    orderId: string;
    vehicleIndex: number;
    options?: TripAssignationStateQueryOptions;
}) {
    const query = useQuery<TripAssignationState, Error>({
        queryKey: getTripAssignationStateQueryKey(orderId, vehicleIndex),
        queryFn: () => getRpcClient().tripAssignationState.getTripAssignationState({ orderId, vehicleIndex }),
        staleTime: 0,
        ...options,
    });

    return query;
}

export const refetchTripAssignationState = (orderId: string, vehicleIndex: number) => {
    return queryClient.refetchQueries({
        queryKey: getTripAssignationStateQueryKey(orderId, vehicleIndex),
        exact: true,
    });
};
